/**
 * Setup the Sentry client.
 *
 * See docs: https://docs.sentry.io/clients/javascript/config/
 */

import * as Sentry from "@sentry/react";

export default function setupSentry() {
  const conf = window._lingoConfig;

  if (!conf.sentryDSN) {
    console.warn("Sentry is not configured");
    return;
  }

  Sentry.init({
    dsn: conf.sentryDSN,
    environment: conf.environment,
    release: conf.sentryRelease,
    allowUrls: [/static.*\.lingoapp\.com/],
    tracesSampleRate: 0.25,
  });
}
